export default __webpack_public_path__ + "static/media/61.6c51c7ae.jpg";